import { defineMessages } from 'react-intl'

const scope = 'app.containers.OrganizationsPage'

export default defineMessages({
  tabTitles: {
    organizations: {
      id: `${scope}.tabTitles.organizations`,
      defaultMessage: 'Organizations',
    },
    users: {
      id: `${scope}.tabTitles.users`,
      defaultMessage: 'Users',
    },
    zones: {
      id: `${scope}.tabTitles.zones`,
      defaultMessage: 'Zones',
    },
    groups: {
      id: `${scope}.tabTitles.groups`,
      defaultMessage: 'Groups',
    },
  },
})
